module.exports = __webpack_public_path__ + "img/logo-circle-smoke.4436fc8b.svg";